
import type { PropType } from 'vue'
import { defineComponent, reactive } from 'vue'

import type { TtnDirection } from '@/new-services/types/tms'

import TheButton from '@/common/components/UI/TheButton/index.vue'

import TtnInvoicesTable from './Table.vue'
import TtnViewManager from '@/modules/TTNModule/components/TtnViewManager/index.vue'

import tmsAPI from '@/new-services/tms.service'
import { useFile } from '@/common/composable/useFile'

export default defineComponent({
    components: {
        TheButton,
        TtnInvoicesTable,
        TtnViewManager,
    },
    props: {
        ttnId: {
            type: Number,
            default: null
        },
        directions: {
            type: Array as PropType<Array<TtnDirection>>,
            default: () => [],
        },
        directionsTwo: {
            type: Array as PropType<Array<TtnDirection>>,
            default: () => [],
        },
    },
    setup(props) {
        const { saveFile } = useFile()

        const state = reactive({
            view: 'sector' as 'sector' | 'direction',
            is_export_loading: false,
        })

        const exportExcel = async () => {
            if (state.is_export_loading || !props.ttnId) return
            
            try {
                state.is_export_loading = true

                const response = await tmsAPI.exportTtnsInvoices(props.ttnId)
                saveFile(response.data, `Накладные и направления по ТТН №${props.ttnId}`)
            } catch (error) {
                console.error
            } finally {
                state.is_export_loading = false
            }
        }

        return {
            state,
            exportExcel
        }
    },
})
